import { useApplicationContext } from '../../common/utils/applicationContext';
import { useDispatch, useSelector } from 'react-redux';
import { selectDefaultRedirectUrl, selectIsCianAuthorized } from '../selectors/calculator';
import { redirect } from '../utils';
import { setAuthorizationModalRedirectUrl, setCianAuthorizedModalOpen } from '../redux';

export const useCianAuthorization = () => {
  const { microfrontendsAPI } = useApplicationContext();
  const dispatch = useDispatch();
  const isCianAuthorized = useSelector(selectIsCianAuthorized);
  const defaultRedirectUrl = useSelector(selectDefaultRedirectUrl);

  const handeCianAuthAction = async () => {
    if (isCianAuthorized) {
      redirect(defaultRedirectUrl);

      return;
    }

    if (microfrontendsAPI) {
      dispatch(setAuthorizationModalRedirectUrl({ redirectUrl: defaultRedirectUrl || null }));
      dispatch(setCianAuthorizedModalOpen(true));
      microfrontendsAPI.header.openAuthModal({
        autoRefresh: false,
        source: null,
      });

      return;
    }
  };

  return handeCianAuthAction;
};
